import { useState, useEffect } from 'react';

interface UseCountUpOptions {
  start?: number;
  end: number;
  duration?: number;
  steps?: number;
  delay?: number;
}

export const useCountUp = ({ 
  start = 0, 
  end, 
  duration = 1000, 
  steps = 60,
  delay = 0 
}: UseCountUpOptions) => {
  const [displayValue, setDisplayValue] = useState(start);
  const [isCounting, setIsCounting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsCounting(true);
      const targetValue = end;
      const increment = (targetValue - start) / steps;
      const stepDuration = duration / steps;
      
      let currentValue = start;
      const countTimer = setInterval(() => {
        currentValue += increment;
        if (currentValue >= targetValue) {
          currentValue = targetValue;
          setIsCounting(false);
          clearInterval(countTimer);
        }
        setDisplayValue(currentValue);
      }, stepDuration);
      
      return () => clearInterval(countTimer);
    }, delay);

    return () => clearTimeout(timer);
  }, [start, end, duration, steps, delay]);

  return { displayValue, isCounting };
};
